import { nullish } from '../../../../shared/types/nullish.ts';
import { Operation } from '../../../types/sharedTypeImpl.ts';
import { formatDatetime, formatOperationDetails } from '../../../utils/fieldFormats.ts';
import { MGraphMeasurement } from '../measurementsGraph.tsx';


export interface OperationMarker {
    afterIndex: number;
    tooltip: string;
}

export function prepareOperationMarkers(
    measurements: MGraphMeasurement[] | null,
    operations: Operation[] | nullish,
): OperationMarker[] | null {
    if (!operations || operations.length === 0 || !measurements || measurements.length === 0) return null;

    const operationMarkers: OperationMarker[] = [];
    for (const operation of operations) {
        if (operation.effectiveTime < measurements[0].date) continue;
        if (operation.effectiveTime > measurements.at(-1)!.date) continue;

        const afterIndex = measurements.findLastIndex(it => it.date < operation.effectiveTime);
        const time = formatDatetime(operation.effectiveTime);
        const details = formatOperationDetails(operation.details, undefined, undefined);
        const comment = operation.comment;
        const tooltip = [time, details, comment].filter(it => it).join('\n');

        const addToPrevious = operationMarkers.at(-1)?.afterIndex === afterIndex;
        if (addToPrevious) {
            const previous = operationMarkers.at(-1)!;
            previous.tooltip += '\n---\n' + tooltip;
        } else {
            const operationMarker = {
                afterIndex,
                tooltip,
            }
            operationMarkers.push(operationMarker);
        }
    }
    return operationMarkers;
}
